const powers = [
    1, 1e1, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13, 1e14, 1e15, 1e16, 1e17,
    1e18, 1e19, 1e20, 1e21, 1e22,
]

function intpow10(power: number) {
    if (power < 0 || power > 22) {
        return Math.pow(10, power)
    }
    return powers[power]
}

export function decimalRound(num: number, decimalPlaces: number) {
    const p = intpow10(decimalPlaces || 0)
    const n = num * p * (1 + Number.EPSILON)
    return Math.round(n) / p
}
